import { useEffect } from "react";
import "@/App.css";

import { SiteProvider, useSite } from "@/lib/SiteContext";
import { seo } from "@/lib/i18n";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import LinesOfExperience from "@/components/site/LinesOfExperience";
import Diferencial from "@/components/site/Diferencial";
import Cobertura from "@/components/site/Cobertura";
import Proceso from "@/components/site/Proceso";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import ContactDialog from "@/components/site/ContactDialog";
import ReferralDialog from "@/components/site/ReferralDialog";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";

function SmoothScroll() {
  // Native scroll — Lenis was causing perceived lag, especially on trackpads.
  // Keep CSS scroll-behavior: smooth for anchor jumps only.
  return null;
}

// Dynamically updates document title, meta description, OG and Twitter tags when locale changes
function SeoSync() {
  const { locale } = useSite();
  useEffect(() => {
    const data = seo[locale] || seo.es;
    document.title = data.title;
    const setMeta = (selector, value, attr = "content") => {
      const el = document.querySelector(selector);
      if (el && value) el.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', data.description);
    setMeta('meta[property="og:title"]', data.ogTitle);
    setMeta('meta[property="og:description"]', data.ogDescription);
    setMeta('meta[property="og:locale"]', locale === "es" ? "es_CO" : "en_US");
    setMeta('meta[name="twitter:title"]', data.ogTitle);
    setMeta('meta[name="twitter:description"]', data.ogDescription);
  }, [locale]);
  return null;
}

function App() {
  return (
    <SiteProvider>
      <SmoothScroll />
      <SeoSync />
      <div className="App relative">
        <Navigation />
        <main>
          <Hero />
          <div className="ix-cv"><Manifesto /></div>
          <div className="ix-cv"><LinesOfExperience /></div>
          <div className="ix-cv"><Diferencial /></div>
          <div className="ix-cv"><Cobertura /></div>
          <div className="ix-cv"><Proceso /></div>
          <div className="ix-cv"><FinalCTA /></div>
        </main>
        <Footer />
        <FloatingWhatsApp />
        <ContactDialog />
        <ReferralDialog />
      </div>
    </SiteProvider>
  );
}

export default App;
